var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGantryControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1699500386674,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2222,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 507.0510665m-509.03316101 0a509.03316101 509.03316101 0 1 0 1018.06632202 0 509.03316101 509.03316101 0 1 0-1018.06632202 0Z",
    fill: "#FFFFFF",
    "p-id": 2223
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M80.73579415 507.0510665c0 238.18509993 193.07910593 431.26420585 431.26420585 431.26420584s431.26420585-193.00840688 431.26420585-431.26420584-193.07910593-431.26420585-431.26420585-431.26420586-431.26420585 193.07910593-431.26420585 431.26420586z m0 0",
    fill: "#3298FF",
    "p-id": 2224
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M701.11995914 666.91929362l44.18690632-0.70699051v-33.10483021a20.67947216 20.67947216 0 1 1 41.34126957 0l-0.54791764 120.01163761a20.44970026 20.44970026 0 0 1-20.07853023 20.32597691 19.88410785 19.88410785 0 0 1-20.23760312-19.61898642l-0.47721858-35.89744271-61.34910076 0.72466526L633.95586149 634.76890058l39.43239522-19.1594426 27.71402765 51.25681135z m0 0",
    fill: "#FFFFFF",
    "p-id": 2225
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M608.62792677 613.78895745c-74.07492978 38.3542347-184.86034135 95.90326153-184.86034134 95.9032615s-23.15393892 6.5573369-35.87976795-4.17124395-40.65195383-88.95707984-40.65195383-88.95707984 51.25681135 48.94141746 57.93787158 45.49483876c102.83176843-53.28940905 357.33067418-190.37486726 357.33067418-190.37486726l24.12605086 49.75445654s-46.55532452 25.25723566-125.490814 66.1389614c-3.5349525 1.76747625-47.72185885 23.77255561-52.44102044 26.21167285z m0 0",
    fill: "#D4EAF5",
    "p-id": 2226
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M777.47493328 440.36418745L416.75070469 628.01714128c-8.18341505 4.31264205-18.29337922 2.43911724-22.55299699-4.15356919L236.60952494 501.39514249c-4.22426826-6.61036119-0.91908765-15.43006769 7.29967693-19.70736024L663.89690924 262.96259587c8.21876458-4.31264205 18.32872875-2.47446676 22.57067174 4.15356922l98.2716797 153.52298737c4.22426826 6.59268642 0.95443717 15.41239294-7.2643274 19.72503499z m0 0",
    fill: "#FFFFFF",
    "p-id": 2227
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGantryControl);
export default __webpack_public_path__ + "static/media/gantry-control.6f82c28d136ab39af0a18114be8f17ce.svg";
export { ForwardRef as ReactComponent };